/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Theme_AutoInputs */



/**
* | output |
* | --- |
* | "Automatic" |
*
* @param {Settings_Theme_AutoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_theme_auto = /** @type {((inputs?: Settings_Theme_AutoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_AutoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Automatisch")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatique")
	return /** @type {LocalizedString} */ ("Automatic")
});